import React, { useEffect, useState } from 'react';
import './style.css'
import { useSiteSettings } from '../../siteSettings';
 
const getRemainingTime = (deadline) => {
    const difference = Math.max(deadline - Date.now(), 0);

    return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / (1000 * 60) % 60),
        seconds: Math.floor(difference / 1000 % 60)
    };
};

const CountdownUnit = ({ value, label }) => (
    <li>
        <p className="digit">{String(value).padStart(2, '0')}</p>
        <p className="text">{label}</p>
    </li>
);

const Saveday = (props) => {
    const settings = useSiteSettings();
    const deadline = settings.weddingDate ? new Date(`${settings.weddingDate}T${settings.weddingTime || '00:00'}`).getTime() : 0;
    const [remaining, setRemaining] = useState(getRemainingTime(deadline));

    useEffect(() => {
        setRemaining(getRemainingTime(deadline));
        if (!deadline) return undefined;
        const timer = setInterval(() => setRemaining(getRemainingTime(deadline)), 1000);
        return () => clearInterval(timer);
    }, [deadline]);

    if (!settings.weddingDate) return null;

    return(
        <div className={`saveday ${props.saveday}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="countdownwrap">
                            <ul className="react-countdown">
                                <CountdownUnit value={remaining.days} label="Jours" />
                                <CountdownUnit value={remaining.hours} label="Heures" />
                                <CountdownUnit value={remaining.minutes} label="Minutes" />
                                <CountdownUnit value={remaining.seconds} label="Secondes" />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Saveday;
